import { FaRegTrashAlt } from "react-icons/fa";
import { useQuantity } from "../../../../hooks/useQuantity";
import styles from "./Quantity.module.scss";
import { useState } from "react";

interface QuantityProps {
  quantity?: number;
  setQuantity?: (n: number) => void;
  idItem?: string;
  productId?: string;
  title?: string;
  price?: number;
  photo?: string | null;
  onRemove?: () => void; // 👈 NUEVO
}

export const Quantity = ({
  quantity,
  setQuantity,
  idItem,
  productId,
  title,
  price,
  photo,
  onRemove
}: QuantityProps) => {

  const isModal = quantity !== undefined && setQuantity !== undefined;

  const [isBouncing, setIsBouncing] = useState(false);

  const {
    qty,
    addItem,
    incrementItem,
    decrementItem,
    removeItem
  } = useQuantity(idItem);

  const currentQty = isModal ? quantity : qty;

  const handleIncrement = () => {
    if (isModal) return setQuantity!(quantity + 1);
    setIsBouncing(true);
    setTimeout(() => setIsBouncing(false), 150);
    if (qty === 0) {
      addItem({
        productId: productId!,
        title: title!,
        price: price ?? 0,
        quantity: 1,
        image_url: photo || null,
      });
      return;
    }

    incrementItem(idItem!);
  };

  const handleDecrement = () => {
    if (isModal) return setQuantity!(Math.max(1, quantity - 1));
  
    if (qty <= 1) {
      onRemove?.(); // 👈 animación primero
  
      setTimeout(() => {
        removeItem(idItem!);
      }, 250);
  
      return;
    }
  
    decrementItem(idItem!);
  };

  const showTrash = !isModal && currentQty <= 1;

  return (
    <div className={styles.quantityWrapper}>
      <div className={styles.containerActive}>
        
        <button
          onClick={handleDecrement}
          className={showTrash ? styles.buttonSignTrash : styles.buttonSign}
        >
          {showTrash ? <FaRegTrashAlt className={styles.trash} /> : "-"}
        </button>

        <small className={`${styles.quantity} ${isBouncing ? styles.bump : ""}`}>
  {currentQty}
</small>

        <button onClick={handleIncrement} className={styles.buttonSign}>
          +
        </button>
      </div>
    </div>
  );
};